import { DefaultTheme } from 'react-native-paper';
import { MaterialCommunityIcons } from 'react-native-vector-icons';

export const theme = {
  ...DefaultTheme,

  dark: false,
  colors: {
    ...DefaultTheme.colors,
    primary: '#1976D2',
    accent: '#FF4081',
    background: '#F5F5F5',
    surface: '#FFFFFF',
    text: '#212121',
    error: '#D32F2F',
    disabled: '#9E9E9E',
    placeholder: '#757575',
    backdrop: 'rgba(0, 0, 0, 0.5)',
    success: '#4CAF50',
    awaiting: '#FFA500',
  }
};
